import Div from '@ui/layout/Div'
import { useSelector } from 'react-redux'
import Image from '@ui/elements/Image'
import { useTranslation } from 'react-i18next'
import Icon from '@ui/elements/Icon'
import Modal from '@ui/component/Modal'
import { useState } from 'react'
import useToggle from '@hook/useToggle'

const MediaManagerContent = () => {
  const { displayedContent } = useSelector(state => state.mediaManager)
  const [t] = useTranslation('sterilization')
  const [activeMedia, setActiveMedia] = useState(null)
  const [isModalActive, toggleModal] = useToggle(false)

  const activateMedia = media => {
    setActiveMedia(media)
    toggleModal()
  }

  const clearModal = () => {
    setActiveMedia(null)
    toggleModal()
  }

  const renderActiveContent = () => {
    if (!displayedContent) {
      return <></>
    }

    return displayedContent.map(media => {
      return (
        <Div cssClass='is-4 column' key={`media-${media.id}`}>
          <Div cssClass='card'>
            <Div cssClass='card-content'>
              <Image src={media.scanPhoto} />
              <Div cssClass='content'>
                <Icon icon='icon-zoom_in' callback={() => activateMedia(media)} />
              </Div>
            </Div>
          </Div>
        </Div>
      )
    })
  }

  return (
    <>
      <Div cssClass='media-manager-content column is-9'>
        <Div cssClass='columns is-multiline'>
          {renderActiveContent()}
        </Div>
      </Div>
      <Modal cssClass='zoom-media-modal' isActive={isModalActive} closeCallback={clearModal} closeAction={true}>
        {
          activeMedia
          && <>
            <Image src={activeMedia.bigScanPhoto} />
            <Div cssClass='media-content'>
              {activeMedia.comment && <p><span>{t('labels.comment')} : </span>{activeMedia.comment}</p>}
              <p><span>{t('labels.treated')} : </span>{activeMedia.isTreated ? t('labels.yes') : t('labels.no')}</p>
              <p><span>{t('labels.mission_subject')} : </span>{activeMedia.missionSubjectName}</p>
              <p><span>{t('labels.scan')} : </span>
                {activeMedia.isFirstScan ? t('labels.first_scan') : (activeMedia.isSecondScan ? t('labels.second_scan') : t('labels.non_indicated'))}</p>
            </Div>
          </>
        }
      </Modal>
    </>

  )
}

export default MediaManagerContent